<template>
    <div>
        <div v-for="(item, index) in list" :key="index" :class="['ds-customer', {block: block}]">
            {{ item[nameKey] }}
            <img v-if="item[autoKey]" style="width:20px;height:20px;" src="@/assets/images/auto.png" alt="">
            <el-tag v-if="item[statusKey] == 2" type="warning" effect="dark" size="small" class="round">审核中</el-tag>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DsCustomer',
    props: {
        block: {
            type: Boolean,
            default: false
        },
        list: {
            type: Array,
            default: () => []
        },
        autoKey: {
            type: String,
            default: 'autoAudit'
        },
        nameKey: {
            type: String,
            default: 'brandName'
        },
        statusKey: {
            type: String,
            default: 'status'
        }
    },
    data() {
        return {

        };
    },
    methods: {

    }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.ds-customer {
    display: inline-block;
    white-space: nowrap;

    &.block {
        display: block;

        & + .ds-customer {
            margin-left: 0;
        }
    }

    & + .ds-customer {
        margin-left: 10px;
    }
}
</style>
